// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"Filters--next-sr-only--18QZh7l","w-15":"Filters--w-15--9eV3rTS","filterContainer":"Filters--filterContainer--mQvD7vr","filter":"Filters--filter--3DLRD67"};